import { createClient } from '@supabase/supabase-js';
import { appConfig } from './env';

const fallbackUrl = 'https://not-configured.supabase.co';
const fallbackKey = 'not-configured';

export const supabase = createClient(
  appConfig.supabaseUrl || fallbackUrl,
  appConfig.supabaseKey || fallbackKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);


export const publicSupabase = createClient(
  appConfig.supabaseUrl || fallbackUrl,
  appConfig.supabaseKey || fallbackKey,
  {
    auth: {
      storageKey: 'stockroom-public-anon',
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
    },
  },
);

export function requireSupabaseConfiguration(): void {
  if (!appConfig.supabaseConfigured) {
    throw new Error(
      'Supabase no está configurado. Copia .env.example a .env.local y completa VITE_SUPABASE_URL y la clave pública.',
    );
  }
}
